export const PROVINCES_URL = '/data/countries.json';
export const VALIDATION_MSG = '/data/validationMsg.json';
export const COOKIES_MSG = '/data/cookies.json';

export const GLOBAL_KEYS = {
    reCaptcha: '6LdkdEEUAAAAALHez3Gp3W_msNTznXxfqudwroEI'
};
